import { render } from "./ObservacionesFinanciador.vue?vue&type=template&id=1655ccc5&scoped=true"
import script from "./ObservacionesFinanciador.vue?vue&type=script&lang=js"
export * from "./ObservacionesFinanciador.vue?vue&type=script&lang=js"

import "./ObservacionesFinanciador.vue?vue&type=style&index=0&id=1655ccc5&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1655ccc5"]])

export default __exports__